import React from "react";
import StopTwoToneIcon from "@mui/icons-material/StopTwoTone";
import { Button, Tooltip } from "@mui/material";
import moment from "moment";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

export default function CustomizedDialogs(props) {
  const { tag, endDate, endTime, startDate, startTime, depends_on, manage_labs, labType } = props;

  function timeDiff(utcEndDate, utcEndTime, utcStartDate, utcStartTime, depends_on, manageLabs) {

    function parseDate(str) {
        const [day, month, year] = str.split("-");
        return new Date(year, month - 1, day); // month is 0-based
    }
    // Convert HH:mm string to minutes since midnight
    function timeToMinutes(timeStr) {
        const [hours, minutes] = timeStr.split(":").map(Number);
        return hours * 60 + minutes;
    }

    function isWithinTimeDifference(currentTimeStr, endTimeStr, diffMinutes) {
        const current = timeToMinutes(currentTimeStr);
        const end = timeToMinutes(endTimeStr);
      
        // Compute time difference, handle wrap-around at midnight using modulo
        const difference = (end - current + 1440) % 1440;
      
        return difference >= 0 && difference <= diffMinutes;
    }

    // Create Date objects from UTC inputs
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    let disable = true;
    let isTimeWithinRange;
    const diffMinutes = (process.env.REACT_APP_DIFFENDTIME || 0); // REACT_APP_DIFFENDTIME
    
    const startUTC = new Date(utcStartDate + "T" + utcStartTime + ":00.000Z").toLocaleString("en-GB", { timeZone: `${timezone}` });
    const startDate2 = startUTC.split(",");
    const startDatef = startDate2[0].replace("/", "-");
    const startDate3 = startDatef.replace("/", "-"); // get the lab Start Date part only
    const startTime2 = startUTC.split(",");
    const startTimeStr = startTime2[1].substring(0, 6); // get the start time part only
    
    const endUTC = new Date(utcEndDate + "T" + utcEndTime + ":00.000Z").toLocaleString("en-GB", { timeZone: `${timezone}` });
    const endDate2 = endUTC.split(",");
    const endDatef = endDate2[0].replace("/", "-");
    const endDate3 = endDatef.replace("/", "-"); // get the end Date part only
    const endTime2 = endUTC.split(",");
    const endTimeStr = endTime2[1].substring(0, 6); // get lab Stop time part only

    // Get current local time
    const now = new Date();
    const currentDate = moment(now).format('DD-MM-YYYY');
    const CurrentTime = now.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false });

    // get parsing Dates
    const startDate_parse = parseDate(startDate3); // get parsing lab start date
    const endDate_parse = parseDate(endDate3); // get parsing lab end date
    const currentDate_parse = parseDate(currentDate); // get parsing current date

    // get parsing Minutes
    const start = timeToMinutes(startTimeStr);
    const end = timeToMinutes(endTimeStr);
    const current = timeToMinutes(CurrentTime);

    // Compare dates (date part only)
    const isWithinDateRange = currentDate_parse >= startDate_parse && currentDate_parse <= endDate_parse;

    // *********************************** Calculate Time range part Start **********************************
    if (end >= start) {
        // Time range does NOT cross midnight
        isTimeWithinRange = current >= start && current <= end;
        } else {
        // Time range crosses midnight (e.g., 23:15 to 00:50)
        isTimeWithinRange = current >= start || current <= end;
    }
        // *********************************** end **********************************

    if (depends_on === "during_training") {
        if (isWithinDateRange) {
            if (isWithinTimeDifference(CurrentTime,  endTimeStr ,diffMinutes)) {
                disable = true;
            }else if (isTimeWithinRange) {
                disable = false;
            }
        }
        // Lab manager override
        if (manageLabs === "yes") {
            disable = false;
        }
        
    } else if (depends_on === "immediate" || depends_on === "always") {
        // Check if within allowed time before end
            if (isWithinDateRange) {
                const endUtc = new Date(`${utcEndDate}T${utcEndTime}:00Z`);
                const totalMinutesRemaining = Math.floor((endUtc - now) / (1000 * 60));
                if (totalMinutesRemaining > diffMinutes) {
                    disable = false;
                }
            }
        }
        return disable;
  }

  

  const [open, setOpen] = React.useState(false);
  const [popupopen, setPopUpOpen] = React.useState(false);
  const [opentitle, setOpentitle] = React.useState();
  const [popupopentitle, setPopupOpentitle] = React.useState("Are you sure you want to stop a lab?.");

  const handleClose = () => {
    setOpen(false);
    setPopUpOpen(false);
  };

  const handlePopUpClose = () => {
    setPopUpOpen(false);
  };

  const handleOpen = () => {
    setPopUpOpen(true);
  };

  const handleSubmitClick = (e) => {
    e.preventDefault();
    let api_call = ""
    const InstanceID = localStorage.getItem("InstanceID");
    if (labType === "custom") {
      api_call = `${process.env.REACT_APP_API_URL}/api/individualstopcustomlab/${InstanceID}/${tag}`
    }
    else if (labType === "hvm") {
      api_call = `${process.env.REACT_APP_API_URL}/api/individualstophvmlab/${InstanceID}/${tag}`
    }
    else if (labType === "wise") {
      api_call = `${process.env.REACT_APP_API_URL}/api/individualstopwiselab/${InstanceID}/${tag}`
    }
    
    fetch(api_call, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data) {
          if (data === "Success") {
            setOpen(false);
            window.location.reload();
          }
          else {
            setOpen(true);
            setOpentitle(data);
          }
        } else if (data && data.name) {
          setOpen(true);
          setOpentitle(data.name[0]);
        }
      })
      .catch((error) => {
        setOpen(false);
        window.location.reload();
      });
  };

  return (
    <div>
      <Dialog
        open={popupopen}
        onClose={handlePopUpClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {popupopentitle} {" "}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description"></DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handlePopUpClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleSubmitClick} color="primary">
            Ok
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {opentitle} {" "}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description"></DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
      <Tooltip title="Stop" arrow>
        <span>
          <Button
            sx={{
              mx: 1,
              width: { xs: "75px", sm: "85px" },
              height: { xs: "23px", sm: "25px" },
              borderRadius: "50px",
              boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
              fontSize: { xs: "0.75rem", sm: "0.875rem" },
            }}
            variant="contained"
            startIcon={<StopTwoToneIcon sx={{ fontSize: { xs: "0.875rem", sm: "1rem" } }} />}
            onClick={handleOpen}
            disabled={timeDiff(endDate, endTime, startDate, startTime, depends_on, manage_labs)}
            aria-label="Stop"
          >
            Stop
          </Button>
        </span>
      </Tooltip>
    </div>
  );
}
